import { render, staticRenderFns } from "./FinancesTransactionsAddIncome.vue?vue&type=template&id=7c72d396&scoped=true"
import script from "./FinancesTransactionsAddIncome.vue?vue&type=script&lang=js"
export * from "./FinancesTransactionsAddIncome.vue?vue&type=script&lang=js"
import style0 from "./FinancesTransactionsAddIncome.vue?vue&type=style&index=0&id=7c72d396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c72d396",
  null
  
)

export default component.exports